import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useWallet } from "@/hooks/useWallet";
import { useState } from "react";
import StripeEmbeddedCheckoutBox from "./StripeEmbeddedCheckout";

const TIER_META: Record<string, { name: string; price: string; priceId: string; credits: string }> = {
  starter: { name: "Starter", price: "$20/mo", priceId: "sub_starter_monthly", credits: "$22 of credits" },
  pro: { name: "Pro", price: "$50/mo", priceId: "sub_pro_monthly", credits: "$57.50 of credits" },
  power: { name: "Power", price: "$100/mo", priceId: "sub_power_monthly", credits: "$120 of credits" },
};

export default function SubscriptionNudgeDialog() {
  const { shouldShowNudge, recommendedTier, dismissNudge } = useWallet();
  const [checkout, setCheckout] = useState(false);
  const tier = TIER_META[recommendedTier];
  return (
    <Dialog open={shouldShowNudge} onOpenChange={(o) => { if (!o) { setCheckout(false); dismissNudge(); } }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>You're a regular — save with a plan</DialogTitle>
          <DialogDescription>
            Based on your last 30 days, the <b className="capitalize">{tier.name}</b> plan ({tier.price}) gives you{" "}
            {tier.credits} — better value than topping up. You can change or cancel anytime.
          </DialogDescription>
        </DialogHeader>
        {checkout ? (
          <StripeEmbeddedCheckoutBox kind="subscription" priceId={tier.priceId} />
        ) : (
          <div className="flex flex-col gap-2 mt-4">
            <Button onClick={() => setCheckout(true)}>Subscribe to {tier.name}</Button>
            <Button variant="ghost" onClick={dismissNudge}>Not now</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}